module.exports = "/images/inquirer-net.png?a4908a2d58b940600060e680779e5cc6";